'use client';

import { useState, useEffect } from 'react';
import { useProspectSelection } from 'src/context/prospects';
import { useTable } from 'src/context/table';
import { AddToListModal, PulseButton } from 'src/components';
import { PulseIconButton } from 'src/components/PulseUI';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

interface GridAddToListButtonProps {
  table?: string;
}

const GridAddToListButton = ({ table: _table = '' }: GridAddToListButtonProps) => {
  const {
    state: [newProviders],
    selectedRows: [rowsAreSelected, setRowsAreSelected],
  } = useProspectSelection();
  const [isMobile, setIsMobile] = useState(false);
  const { showIcon } = useTable();
  const [showAddProvidersDialog, setShowAddProvidersDialog] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 1023px)');
    setIsMobile(mediaQuery.matches);

    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  return (
    <>
      {isMobile || showIcon ? (
        <PulseIconButton
          variant="soft"
          color="neutral"
          icon={faPlus}
          onClick={() => setShowAddProvidersDialog(true)}
          disabled={!newProviders.length}
          aria-label="Add to List"
          tooltip="Add to List"
          className="font-black"
        />
      ) : (
        <PulseButton
          variant="soft"
          color="neutral"
          className="rounded-full font-black whitespace-nowrap"
          onClick={() => setShowAddProvidersDialog(true)}
          disabled={!newProviders.length}
          startDecorator={faPlus}
        >
          Add
        </PulseButton>
      )}
      <AddToListModal
        isOpen={showAddProvidersDialog}
        onClose={() => {
          setRowsAreSelected(!rowsAreSelected);
          setShowAddProvidersDialog(false);
        }}
        mode="add"
        providers={newProviders}
      />
    </>
  );
};

export default GridAddToListButton;
